import axios, { AxiosResponse } from 'axios';
import urlConfig from '../Configurations/urlConfig';
import { Dialog } from 'vant';
import router from '@/router';

const axiosInstanceNormal = axios.create();
const axiosInstanceUpload = axios.create();

export interface responseData<t = any> {
  readonly code: number;
  readonly data: t;
  readonly message: string;
  readonly status: 0 | 1 | 2;
}

axiosInstanceNormal.defaults.baseURL = urlConfig.httpRequestUrl;
axiosInstanceNormal.defaults.adapter = require('axios/lib/adapters/http');

// 请求超时时间
axiosInstanceNormal.defaults.timeout = 120000;
// 白名单配置
axiosInstanceNormal.defaults.withCredentials = false;
// post请求头
axiosInstanceNormal.defaults.headers['Content-Type'] = 'application/json';
// 请求拦截器
axiosInstanceNormal.interceptors.request.use(
  config => {
    let tempToken = localStorage.getItem('token') || localStorage.getItem('token_for_login') || '';
    if(tempToken && tempToken.length>0){
      config.headers.token = tempToken;
    }
    //post里面统一加上reqtimestamp的时间戳
    if(config.data){
      config.data.reqtimestamp = new Date().getTime();
    }
    return config;
  },
  e => {
    console.log(e);
  }
);

axiosInstanceNormal.interceptors.response.use(
  (response): any =>
    // if (response.data.status === 1) {
    Promise.resolve(response), // 这里使用断言    // } else {
  //   return Promise.reject(response.data.message);
  // }

  error => Promise.reject(error)
);
//这里进行随机选择一个地址进行访问
if(urlConfig.uploadRequestUrlList!=undefined && urlConfig.uploadRequestUrlList.length>0){
  let count = urlConfig.uploadRequestUrlList.length-1;
  if(count>0){
    //随机取出一个域名用来请求
    let randIndex = Math.floor(Math.random()*count);
    let tmpUrl = urlConfig.uploadRequestUrlList[randIndex];
    if(tmpUrl != "" && tmpUrl !=null && tmpUrl.length>0){
      //随机第一个地址出来
      urlConfig.uploadRequestUrl = tmpUrl;
    }
    console.log("config.uploadUrl:"+urlConfig.uploadRequestUrl);
  }
}
// 上传实例
axiosInstanceUpload.defaults.baseURL = urlConfig.uploadRequestUrl;
// 请求超时时间
// axiosInstanceUpload.defaults.timeout = 20000;
// 白名单配置
axiosInstanceUpload.defaults.withCredentials = false;
// post请求头
axiosInstanceUpload.defaults.headers['Content-Type'] = 'multipart/form-data';
// 请求拦截器
axiosInstanceUpload.interceptors.request.use(
  config => {
    config.headers.token = localStorage.getItem('token') || localStorage.getItem('token_for_login') || '';
    //post里面统一加上reqtimestamp的时间戳
    if(config.data){
      config.data.reqtimestamp = new Date().getTime();
    }
    return config;
  },
  e => {
    console.log(e);
  }
);
// 响应拦截器
axiosInstanceUpload.interceptors.response.use(
  (response): any => Promise.resolve(response), // 这里使用断言
  error => Promise.reject(error)
);

/**
 * post，主要用于代码提示
 * @param url [请求的url地址]
 * @param params [请求时携带的参数]
 */

const post = <t>(url: string, params?: object, showError = true): Promise<t> =>
  axiosInstanceNormal
    .post(url, params)
    .then(res => {
      const responseData = res.data as responseData<t>;
      if (responseData.status === 1) {
        const data = responseData.data as t;
        return Promise.resolve(data);
      }
      // todo 后端接口通了，但是报错
      if (showError) {
        Dialog.alert({
          title: '系统提示',
          allowHtml:true,

          message: responseData.message || 'error'
        }).then(() => {
          // 账号失效
          if (responseData.code === 20003) {
            // 清空token
            sessionStorage.clear();
            localStorage.clear();
            // 跳转login页面
            router.replace({
              path: '/login'
            });
          }else if(responseData.code === 30202){
            //如果学生访问老师发生权限错误跳转首页。
            //清除掉 courseId的值
            localStorage.removeItem("courseId");
            sessionStorage.removeItem("courseId");
            router.replace({
              path: '/ktpCourse'
            });
          }
        });
      }
      return Promise.reject(responseData);
    })
    .catch(e => Promise.reject(e));

/*
 * get
 * @param url 请求地址
 * @param params 请求参数
 * */
const get = <t>(url: string, params?: object): Promise<t> =>
  axiosInstanceNormal
    .get(url, params)
    .then(res => {
      const responseData = res.data as responseData<t>;
      if (responseData.status === 1) {
        const data = responseData.data as t;
        return Promise.resolve(data);
      }
      return Promise.reject(responseData);
    })
    .catch(e => Promise.reject(e));

/*
 * upload
 * @param url [请求的url地址]
 * @param params [请求时携带的参数]
 */
const upload = <t>(url: string, params: any): Promise<t> =>
  axiosInstanceUpload
    .post(url, params)
    .then(res => {
      const responseData = res.data as responseData<t>;
      if (responseData.status === 1) {
        const data = responseData.data as t;
        return Promise.resolve(data);
      }
      Dialog.alert({
        title: '上传文件失败',
        message: responseData.message || 'error'
      });
      return Promise.reject(responseData);
    })
    .catch(e => Promise.reject(e));

const uploadSplice = <t>(url: string, param: FormData): Promise<responseData<t>> => {
  return axiosInstanceUpload
    .post(url, param)
    .then(res => {
      const responseData = res.data as responseData<t>;
      return Promise.resolve(responseData);
    })
    .catch(e => Promise.reject(e));
};

export { post, get, upload, uploadSplice };
